// extracted by mini-css-extract-plugin
export var button = "_du-0";
export var icon = "_du-1";